import React from 'react';
import './Allcss.css'
function TopImg() {
  return (
    <div >
        <center >  
               <img className="topImg" src="https://www.abl.com/src/uploads/2019/07/Secure-Online-Shopping.jpg" width="90%" height="300px" />
   
</center>   
    </div>
  );
}

export default TopImg;